import { ISortingModel } from "../../../../Common/models/grid";

export const pendingRequestsDefaultSorting = {
  field: "MemberName",
  sort: "asc",
} as ISortingModel;
